@if (gridInformations) {
  <div class="relative h-full w-full" #gridWithActionsGridContainer>
    @if (isMaterialGrid) {
      <sia-mat-grid
        [gridId]="gridInformations.componentId"
        [pageData]="pageData"
        [allowCompact]="compactMatGrid"
        [enableGlobalFilterPanel]="compactMatGrid"
        [roundCorners]="compactMatGrid"
        [allowViews]="allowViews"
        [showActions]="true"
        [pageSize]="fixedRecords ?? 50"
      >
      </sia-mat-grid>
    } @else {
      <sia-grid
        [gridInformations]="gridInformations"
        [isPopUp]="isPopUp"
        [gridConfId]="gridConfId"
        [gridHeight]="gridWithActionsGridContainer.offsetHeight"
        [saveGridState]="saveGridState"
        (selectedRowsDataChange)="selectedRowsData.emit($event)"
        [(selectedKeys)]="gridWithActionsKeys"
      >
      </sia-grid>
    }
  </div>
}
